export default {"src":"/_next/static/media/0x8700daec35af8ff88c16bdf0418774cb3d7599b4.a00108f4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};